import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { Box } from '../Box/index.js';
import { getCardStyles } from '../Card/Card.js';

/**
 * AccordionItem contains all the parts of a collapsible section.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/accordion#usage)
 * - [Props](https://blockparty.endpoint.com/components/accordion#props)
 * <br />
 *
 */
const AccordionItem = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    variant = 'outline',
    dataTestId = 'accordion-item',
    ...props
  } = _ref;
  const accordionStyles = getCardStyles(variant);
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    as: AccordionPrimitive.Item,
    borderRadius: "radiusDefault",
    "data-test-id": dataTestId,
    overflow: "visible"
  }, accordionStyles, props), children);
});
AccordionItem.displayName = 'AccordionItem';

export { AccordionItem };
